import api from './api';

const propertyService = {
  async search(params = {}) {
    const { data } = await api.get('/properties/search', { params });
    return data; // { properties, total, page, totalPages }
  },

  async getFeatured(limit = 10) {
    const { data } = await api.get('/properties/featured', { params: { limit } });
    return data; // array of properties
  },

  async getById(id) {
    const { data } = await api.get(`/properties/${id}`);
    return data;
  },

  async create(propertyData) {
    const { data } = await api.post('/properties', propertyData);
    return data;
  },

  async update(id, propertyData) {
    const { data } = await api.put(`/properties/${id}`, propertyData);
    return data;
  },

  async delete(id) {
    await api.delete(`/properties/${id}`);
  },

  async getMyProperties() {
    const { data } = await api.get('/properties/owner/my-properties');
    return data;
  },

  /** Report a listing. Reason must be one of the backend enum values. */
  async report(propertyId, { reason, message }) {
    const { data } = await api.post(`/properties/${propertyId}/report`, { reason, message });
    return data;
  },

  /**
   * List reviews for a property.
   * Returns: { reviews, total, totalPages, page, average, breakdown:{1..5}, mine }
   */
  async listReviews(propertyId, params = {}) {
    const { data } = await api.get(`/properties/${propertyId}/reviews`, { params });
    return data;
  },

  /** Create OR update (idempotent — backend upserts on (property, reviewer)) */
  async createReview(propertyId, { rating, comment }) {
    const { data } = await api.post(`/properties/${propertyId}/reviews`, { rating, comment });
    return data;
  },

  async updateReview(reviewId, { rating, comment }) {
    const { data } = await api.put(`/properties/reviews/${reviewId}`, { rating, comment });
    return data;
  },

  async deleteReview(reviewId) {
    await api.delete(`/properties/reviews/${reviewId}`);
  },
};

export default propertyService;
